export class SubmissionSessionParent {
  constructor() {
    this.list = []
  }

  addSubmissionSession(item) {
    this.list.push(SubmissionSession.buildFromAPI(item))
  }

  updateSubmissionSession(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, SubmissionSession.buildFromAPI(item))
  }

  removeSubmissionSession(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => SubmissionSession.buildFromAPI(el))
    }
    return this
  }
}

export class SubmissionSession {
  constructor() {
        this.id = null
        this.semester = null
        this.year = null
        this.isActual = null
      }

  getForAPI() {
    return {
            id: this.id,
            semester: this.semester,
            year: this.year,
            isActual: this.isActual,
          }
  }

  static buildFromAPI(obj) {
    const _this = new SubmissionSession()
    if (obj) {
            _this.id = obj.id
            _this.semester = obj.semester
            _this.year = obj.year
            _this.isActual = obj.isActual
          }
    return _this
  }
}